import React, {useEffect, useState} from 'react';
import ProgramOutlineView from "../../views/ver_24.10/ProgramOutline/ProgramOutline.view";
import { useHistory } from "react-router-dom";
import {toastWarning} from "../../utils/utils";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {fetchProgramOutlineService, removeUnitProgramPublicService} from "../../services/public.service";
import {CHAT_TYPE, LOCAL_STORAGE_KEYS, PBDQ3_PROGRAM_STATE} from "../../utils/constants";
import {updateProgramStatusPublicService} from "../../services/public.service";

const ProgramOutlinePage = () => {

    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [chatHistory, setChatHistory] = useState([]);
    const [programData, setProgramData] = useState({});
    const [unitsData, setUnitsData] = useState([]);


    useEffect(() => {
        setShowLoader(true);
        fetchProgramOutline().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const fetchProgramOutline = async () => {
        setShowLoader(true);
        const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
        if (fingerprint) {
            const result = await fetchProgramOutlineService(fingerprint);
            setProgramData(result.data.programData);
            setUnitsData(result.data.unitsData);
            console.log('programData:', result.data.programData);
            console.log('unitsData:', result.data.unitsData);
        }
        setShowLoader(false);
    };

    const data = {
        programData,
        unitsData,
        chats: chatHistory
    };

    // Actions handling business logic
    const actions = {
        goHome: () => {
            history.push('/'); // Redirect to the home page
        },
        registerAndGenerate: () => {
            history.push('/subscribe'); // Redirect to the subscription page
        },
        removeUnit: async (program_id, unitId) => {
            setShowLoader(true);
            try {
                const result = await removeUnitProgramPublicService(program_id, unitId);
                if (result && result.data) {
                    setProgramData(result.data.programData);
                    setUnitsData(result.data.unitsData);
                }
            } catch (error) {

            }
            setShowLoader(false);
        },
        removeSession: (sessionId) => {
            toastWarning('Not Implemented !!')
        },
        sendMessageAction: (message) => {
            if (message === 'clear') {
                localStorage.clear();
                history.push('/');
            }

            setChatHistory((prevChatHistory) => [
                ...prevChatHistory,
                { type: CHAT_TYPE.USER, text: message },
            ]);

            return new Promise((resolve) => {
                setTimeout(() => {
                    let responseData;

                    setChatHistory(async (prevChatHistory) => {
                        const updatedChatHistory = [...prevChatHistory];

                        const chatLength = updatedChatHistory.filter(
                            (msg) => msg.type === CHAT_TYPE.USER
                        ).length;

                        switch (chatLength) {
                            case 1:
                                responseData = {
                                    response_message:
                                        'Sure, I can help you with your program outline.',
                                    programId: 'programId123',}
                                break;
                            case 2:
                                responseData = {
                                    response_message: 'What changes would you like to make?',}
                                break;
                            case 3:
                                responseData = {
                                    response_message:
                                        'Your program outline has been updated!',
                                    programId: 'programId123',
                                };
                                break;
                            case 4:
                            default:
                                responseData = {
                                    response_message: 'Thank you for using our service!',
                                };
                                break;
                        }
                        updatedChatHistory.push({
                            type: CHAT_TYPE.BOT,
                            text: responseData.response_message,
                        });

                        resolve({ data: responseData });
                        if (responseData.programId) {
                            const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_fingerprint);
                            if (fingerprint) {
                                setShowLoader(true);
                                await updateProgramStatusPublicService(fingerprint, PBDQ3_PROGRAM_STATE.OUTLINE_GENERATED);
                                setShowLoader(false);
                                history.push('/program-dashboard');
                            }

                        }
                        return updatedChatHistory;
                    });
                }, 200);
            });
        },

    };

    // Configuration options for visual appearance
    const options = {
        height: '210px',
        chatType: 'programOutline',
        chatPreview: false,
    };

    if (showLoader) {
        return <Loader />;
    }
    return (
        <div>
            <ProgramOutlineView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
};

export default ProgramOutlinePage;